import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/dashboard',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/DashboardView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/errors',
      name: 'errors',
      component: () => import('@/views/ErrorsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/errors/:id',
      name: 'error-detail',
      component: () => import('@/views/ErrorDetailView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/SettingsView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/integration',
      name: 'integration',
      component: () => import('@/views/IntegrationView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/products/:productId/integration',
      name: 'product-integration',
      component: () => import('@/views/IntegrationView.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/error/:type?',
      name: 'error-page',
      component: () => import('@/views/ErrorPage.vue'),
      meta: { requiresAuth: false },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      redirect: '/error/404',
    },
  ],
});

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();

  // Wait for auth to initialize before making routing decisions
  if (!authStore.initialized) {
    await new Promise<void>((resolve) => {
      const unwatch = authStore.$subscribe((_mutation, state) => {
        if (state.initialized) {
          unwatch();
          resolve();
        }
      });

      // Fallback timeout in case initialization never completes
      setTimeout(() => {
        unwatch();
        resolve();
      }, 5000);
    });
  }

  const requiresAuth = to.meta.requiresAuth !== false;
  const isAuthenticated = authStore.isAuthenticated;

  if (requiresAuth && !isAuthenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } });
  } else if (to.name === 'login' && isAuthenticated) {
    next({ name: 'dashboard' });
  } else {
    next();
  }
});

export default router;
